import { gettext } from '@eventbrite/i18n';

export const TAX_IDENTIFIER_TYPE_CPF = 'CPF';
export const TAX_IDENTIFIER_TYPE_CNPJ = 'CNPJ';
export const TAX_IDENTIFIER_TYPE_PASSPORT = 'PASSPORT';

export const IDENTIFICATION_METHOD_CPF = {
    value: TAX_IDENTIFIER_TYPE_CPF,
    display: TAX_IDENTIFIER_TYPE_CPF,
};

export const IDENTIFICATION_METHOD_CNPJ = {
    value: TAX_IDENTIFIER_TYPE_CNPJ,
    display: TAX_IDENTIFIER_TYPE_CNPJ,
};

export const IDENTIFICATION_METHOD_PASSPORT = {
    value: TAX_IDENTIFIER_TYPE_PASSPORT,
    display: gettext('Passport/Other'),
};
